import {
  NoShowReason,
  UNKNOWN_NO_SHOW_REASON,
  type NoShowBreakdownKey
} from "api/crm-analytics";

const NO_SHOW_BREAKDOWN_KEYS: NoShowBreakdownKey[] = [
  ...Object.values(NoShowReason),
  UNKNOWN_NO_SHOW_REASON
];

export const NO_SHOW_REASON_LABELS: Record<NoShowBreakdownKey, string> = {
  [NoShowReason.NEVER_CHECKED_IN]: "Never checked in",
  [NoShowReason.LOCKBOX_CODE_UNAVAILABLE]: "Lockbox code couldn't be sent",
  [NoShowReason.CHECKED_IN_MARKED_BY_TEAM]:
    "Checked in, marked No show by team",
  [NoShowReason.GUIDED_DID_NOT_CHECK_IN]: "Guided · did not check in",
  [NoShowReason.NO_ENTRY_REPLY]: "No reply to entry check",
  [UNKNOWN_NO_SHOW_REASON]: "Unknown"
};

const NO_SHOW_REASON_SWATCH_CLASSNAMES: Record<NoShowBreakdownKey, string> = {
  [NoShowReason.NEVER_CHECKED_IN]: "bg-content-1000",
  [NoShowReason.LOCKBOX_CODE_UNAVAILABLE]: "bg-warning-600",
  [NoShowReason.CHECKED_IN_MARKED_BY_TEAM]: "bg-content-200",
  [NoShowReason.GUIDED_DID_NOT_CHECK_IN]: "bg-primary-100",
  [NoShowReason.NO_ENTRY_REPLY]: "bg-warning-200",
  [UNKNOWN_NO_SHOW_REASON]: "bg-alpha-200"
};

export const NO_SHOW_REASON_PILL_CLASSNAMES: Record<
  NoShowBreakdownKey,
  string
> = {
  [NoShowReason.NEVER_CHECKED_IN]: "bg-background-800 text-content-1000",
  [NoShowReason.LOCKBOX_CODE_UNAVAILABLE]: "bg-warning-50 text-warning-800",
  [NoShowReason.CHECKED_IN_MARKED_BY_TEAM]:
    "bg-background-1000 text-content-700 border border-alpha-200",
  [NoShowReason.GUIDED_DID_NOT_CHECK_IN]: "bg-primary-20 text-primary-700",
  [NoShowReason.NO_ENTRY_REPLY]: "bg-warning-50 text-warning-700",
  [UNKNOWN_NO_SHOW_REASON]: "bg-background-800 text-content-400"
};

export const toNoShowBreakdownKey = (
  reason: string | null | undefined
): NoShowBreakdownKey =>
  reason && reason in NO_SHOW_REASON_LABELS
    ? (reason as NoShowBreakdownKey)
    : UNKNOWN_NO_SHOW_REASON;

export const toNoShowBreakdownSegments = (
  breakdown: Partial<Record<NoShowBreakdownKey, number>> | undefined
) =>
  breakdown
    ? NO_SHOW_BREAKDOWN_KEYS.map((key) => ({
        key,
        label: NO_SHOW_REASON_LABELS[key],
        count: breakdown[key] ?? 0,
        swatchClassName: NO_SHOW_REASON_SWATCH_CLASSNAMES[key]
      }))
    : undefined;
